import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateBlogPostBuilderProjectStatusArgs,
  BackendProject,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderProjectStatus($projectId: ID!, $status: String!) {
    updateBlogPostBuilderProjectStatus(projectId: $projectId, status: $status) {
      id
      name
      status
    }
  }
`;

type Variables = BackendMutationUpdateBlogPostBuilderProjectStatusArgs;
type Result = Pick<BackendProject, 'id' | 'name' | 'status'>;

export const updateBlogPostBuilderProjectStatus = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
